import React from 'react';
import { isFunction, callAll } from '#lib/utils/function.js';

const PreviewContext = React.createContext();

export default function Preview(props) {
    const { children } = props;
    const [show, setShow] = React.useState(window.innerWidth > 1700);
    const [fullScreen, setFullScreen] = React.useState(false);
    const [didAnimate, setDidAnimate] = React.useState(false);

    return (
        <PreviewContext.Provider value={{ show, setShow, fullScreen, setFullScreen, didAnimate, setDidAnimate }}>
            {isFunction(children)
                ? children({ show, setShow, fullScreen, setFullScreen, didAnimate, setDidAnimate })
                : children}
        </PreviewContext.Provider>
    );
}

function OpenButton(props) {
    const { children, onClick, ...rest } = props;
    const { setShow, setDidAnimate } = React.useContext(PreviewContext);

    const open = React.useCallback(() => {
        setShow(true);
        setDidAnimate(false);
    }, [setShow, setDidAnimate]);

    return React.createElement('button', { onClick: callAll(onClick, open), ...rest }, children);
}

function CloseButton(props) {
    const { children, onClick, ...rest } = props;
    const { setShow, setDidAnimate } = React.useContext(PreviewContext);

    const close = React.useCallback(() => {
        setShow(false);
        setDidAnimate(false);
    }, [setShow, setDidAnimate]);

    return React.createElement('button', { onClick: callAll(onClick, close), ...rest }, children);
}

function Placeholder(props) {
    const { onTransitionEnd, ...rest } = props;
    const { setDidAnimate } = React.useContext(PreviewContext);

    return <div onTransitionEnd={callAll(onTransitionEnd, () => setDidAnimate(true))} {...rest} />;
}

Preview.OpenButton = OpenButton;
Preview.CloseButton = CloseButton;
Preview.Placeholder = Placeholder;
